const { flex } = window;
const { React } = flex.lib;

import { RX } from '../../constants/rx';

const { InfoModal } = flex.components.Modals;

function LandingModal(props) {
    const { content } = props;

    const onCloseClick = () => {
        flex.trigger(RX.LANDING.CHANGE_IS_LANDING_MODAL_OPENED, false);
    };

    return (
        content && (
            <InfoModal title="Information" closeText="Close" onClose={onCloseClick}>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </InfoModal>
        )
    );
}

export default LandingModal;
